export default{  
  setValue(state, payload){
    state.chatsound = payload.chatsound===0 || !payload.chatsound?false:true;
    state.chatfontcolor = payload.chatfontcolor;
    state.chatfontsize = payload.chatfontsize;
  },
  addMtmJoin(state, payload)
  {    
    //같은 내역 있는지 체크 해서 없으면 삽입
    const findItem = state.mtm_join.find((mtm_room)=>mtm_room.room === payload.room);
    //console.log('1:1채팅이 이미 등록되어있는지 체크',findItem);
    const idx = state.mtm_join.indexOf(findItem);
    console.log('1:1채팅 방 체크',idx);
    if(idx <=0){
      state.mtm_join.push(payload)
    }
    
  },
  outMtmJoin(state, payload)
  {
    const findItem = state.mtm_join.find((mtm_room)=>mtm_room.room === payload.room);
    const idx = state.mtm_join.indexOf(findItem);
    state.mtm_join.splice(idx,1);
  }
  
};
